document.documentElement.classList.remove('no-js');
(function(){
  function init(root=document){
    const header=root.querySelector?.('[data-site-header]')||document.querySelector('[data-site-header]');
    if(header && !header.dataset.ready){
      header.dataset.ready='1';
      const toggle=header.querySelector('[data-menu-toggle]');
      toggle?.addEventListener('click',()=>header.classList.toggle('menu-open'));
      window.addEventListener('scroll',()=>header.classList.toggle('is-scrolled',window.scrollY>8),{passive:true});
      header.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>header.classList.remove('menu-open')));
    }
    root.querySelectorAll?.('[data-faq-item]').forEach(item=>{
      if(item.dataset.ready)return; item.dataset.ready='1';
      item.querySelector('button')?.addEventListener('click',()=>item.classList.toggle('is-open'));
    });
    root.querySelectorAll?.('[data-gallery]').forEach(g=>{
      if(g.dataset.ready)return;g.dataset.ready='1';
      const main=g.querySelector('[data-main-image]');
      g.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>{if(main){main.src=b.dataset.src;main.alt=b.dataset.alt||'';}}));
    });
    root.querySelectorAll?.('[data-qty]').forEach(q=>{
      if(q.dataset.ready)return;q.dataset.ready='1';
      const input=q.querySelector('input');
      q.querySelector('[data-minus]')?.addEventListener('click',()=>input.value=Math.max(1,(+input.value||1)-1));
      q.querySelector('[data-plus]')?.addEventListener('click',()=>input.value=(+input.value||1)+1);
    });
    root.querySelectorAll?.('[data-ajax-product-form]').forEach(form=>{
      if(form.dataset.ready)return;form.dataset.ready='1';
      const status=form.querySelector('[data-status]');
      form.addEventListener('submit',async e=>{
        e.preventDefault(); const btn=form.querySelector('[type=submit]'); if(btn)btn.disabled=true;
        if(status)status.textContent='Adding to cart…';
        try{const r=await fetch(window.Shopify?.routes?.root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});if(!r.ok)throw new Error('Unable to add this item.');await r.json();if(status)status.textContent='Added to cart.';document.dispatchEvent(new CustomEvent('cart:refresh'));}
        catch(err){if(status)status.textContent=err.message||'Unable to add this item.';}finally{if(btn)btn.disabled=false;}
      });
    });
  }
  document.addEventListener('DOMContentLoaded',()=>init(document));
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();